import { render, staticRenderFns } from "./hotelNote.vue?vue&type=template&id=28c35120"
import script from "./hotelNote.vue?vue&type=script&lang=js"
export * from "./hotelNote.vue?vue&type=script&lang=js"
import style0 from "./hotelNote.vue?vue&type=style&index=0&id=28c35120&prod&lang=stylus&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports